import {Service, service, inject} from "./di";

@service
export class BannerService extends Service {

	isSmartNews() {
		const synd = sessionStorage.getItem("synd");
		return synd === "smartnews";
	}
}
